import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from '@routingModule';
import { SharedModule } from '../../../shared/shared.module';
import { PrimengModule } from '@modules/primeng.module';

import { DadosContaComponent } from './components/dados-conta.component';

@NgModule({
  declarations: [
    DadosContaComponent,
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SharedModule,
    PrimengModule,
  ],
})
export class DadosContaModule { }
